import React, { useState } from 'react';
import { ArrowLeft, Calendar as CalendarIcon } from 'lucide-react';

interface Props {
  onBack: () => void;
  onSave?: () => void;
}

export const BoardMembersSettingsView: React.FC<Props> = ({ onBack, onSave }) => {
  const [startDate, setStartDate] = useState('2031-02-01');
  const [endDate, setEndDate] = useState('2032-02-01');
  const [memberCountType, setMemberCountType] = useState('6');
  const [customMemberCount, setCustomMemberCount] = useState('');
  const [note, setNote] = useState('TEST');

  const handleSave = () => {
    if (onSave) onSave();
  };

  return (
    <div className="bg-white min-h-[480px] rounded-xl p-6 sm:p-8 font-prompt space-y-6">
      {/* Top Header */}
      <div className="flex items-center gap-3 pb-2">
        <button
          type="button"
          onClick={onBack}
          className="w-8 h-8 rounded-full border border-slate-300 hover:border-slate-400 bg-white flex items-center justify-center text-slate-600 hover:text-slate-900 transition-colors cursor-pointer"
          title="ย้อนกลับ"
        >
          <ArrowLeft className="w-4 h-4" />
        </button>
        <h1 className="text-xl sm:text-2xl font-bold text-slate-800 tracking-tight">
          ตั้งค่าคณะกรรมการ
        </h1>
      </div>

      <div className="space-y-6 pt-2 max-w-4xl">
        {/* Row 1: Term Dates & Member Count */}
        <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
          {/* Term Dates */}
          <div className="space-y-2">
            <label className="text-sm sm:text-base font-bold text-slate-800 block">
              วาระของคณะกรรมการ
            </label>
            <div className="flex items-center gap-2">
              <div className="relative flex items-center">
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  className="py-1.5 px-3 text-xs sm:text-sm border border-slate-300 rounded-md bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
              </div>

              <span className="text-xs sm:text-sm text-slate-600 font-medium">ถึง</span>

              <div className="relative flex items-center">
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  className="py-1.5 px-3 text-xs sm:text-sm border border-slate-300 rounded-md bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Member Count */}
          <div className="flex items-center gap-2 lg:self-end">
            <span className="text-xs sm:text-sm font-medium text-slate-700">
              จำนวนคณะกรรมการในวาระนี้
            </span>
            <select
              value={memberCountType}
              onChange={(e) => setMemberCountType(e.target.value)}
              className="py-1.5 px-3 text-xs sm:text-sm border border-slate-300 rounded-md bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-500 cursor-pointer min-w-[70px]"
            >
              <option value="3">3</option>
              <option value="4">4</option>
              <option value="5">5</option>
              <option value="6">6</option>
              <option value="7">7</option>
              <option value="8">8</option>
              <option value="9">9</option>
              <option value="custom">ระบุเอง</option>
            </select>

            {memberCountType === 'custom' && (
              <input
                type="number"
                min={1}
                placeholder="ระบุ"
                value={customMemberCount}
                onChange={(e) => setCustomMemberCount(e.target.value)}
                className="w-16 py-1.5 px-2 text-xs sm:text-sm border border-slate-300 rounded-md bg-white text-slate-800 focus:outline-none focus:ring-1 focus:ring-blue-500 text-center"
              />
            )}

            <span className="text-xs sm:text-sm text-slate-700">คน</span>
          </div>
        </div>

        {/* Row 2: Note */}
        <div className="space-y-2">
          <label className="text-sm sm:text-base font-bold text-slate-800 block">
            หมายเหตุ
          </label>
          <textarea
            rows={5}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            className="w-full p-3 text-xs sm:text-sm text-slate-700 bg-white border border-slate-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>

        {/* Action Buttons (Bottom Left as in Image 5) */}
        <div className="flex items-center gap-3 pt-4">
          <button
            type="button"
            onClick={handleSave}
            className="px-6 py-2.5 bg-blue-700 hover:bg-blue-800 text-white rounded-md text-sm font-semibold transition-colors shadow-xs cursor-pointer"
          >
            บันทึกข้อมูล
          </button>
          <button
            type="button"
            onClick={onBack}
            className="px-6 py-2.5 bg-slate-300 hover:bg-slate-400 text-slate-700 rounded-md text-sm font-semibold transition-colors cursor-pointer"
          >
            ยกเลิก
          </button>
        </div>
      </div>
    </div>
  );
};
